// KYC 民族字段（5.1）本地兜底翻译；线上真实翻译走 CDN（MTS），本地仅在 CDN 失效时兜底
// NOTE: MTS 录入为独立 ops 步骤，需运营/翻译团队在 MTS 后台补齐 `Setting` group 下的 56 个 KYCEthnic<key> 词条（不含 KO）
export const Setting = {
    KYCEthnic: 'Ethnic Group',
    'KYCEthnicCN-ETH-HA': 'Han',
    'KYCEthnicCN-ETH-MG': 'Mongol',
    'KYCEthnicCN-ETH-HU': 'Hui',
    'KYCEthnicCN-ETH-ZA': 'Tibetan',
    'KYCEthnicCN-ETH-UG': 'Uyghur',
    'KYCEthnicCN-ETH-MH': 'Miao',
    'KYCEthnicCN-ETH-YI': 'Yi',
    'KYCEthnicCN-ETH-ZH': 'Zhuang',
    'KYCEthnicCN-ETH-BY': 'Bouyei',
    'KYCEthnicCN-ETH-CS': 'Korean',
    'KYCEthnicCN-ETH-MA': 'Manchu',
    'KYCEthnicCN-ETH-DO': 'Dong',
    'KYCEthnicCN-ETH-YA': 'Yao',
    'KYCEthnicCN-ETH-BA': 'Bai',
    'KYCEthnicCN-ETH-TJ': 'Tujia',
    'KYCEthnicCN-ETH-HN': 'Hani',
    'KYCEthnicCN-ETH-KZ': 'Kazakh',
    'KYCEthnicCN-ETH-DA': 'Dai',
    'KYCEthnicCN-ETH-LI': 'Li',
    'KYCEthnicCN-ETH-LS': 'Lisu',
    'KYCEthnicCN-ETH-VA': 'Va',
    'KYCEthnicCN-ETH-SH': 'She',
    'KYCEthnicCN-ETH-GS': 'Gaoshan',
    'KYCEthnicCN-ETH-LH': 'Lahu',
    'KYCEthnicCN-ETH-SU': 'Sui',
    'KYCEthnicCN-ETH-DX': 'Dongxiang',
    'KYCEthnicCN-ETH-NX': 'Naxi',
    'KYCEthnicCN-ETH-JP': 'Jingpo',
    'KYCEthnicCN-ETH-KG': 'Kyrgyz',
    'KYCEthnicCN-ETH-TU': 'Tu',
    'KYCEthnicCN-ETH-DU': 'Daur',
    'KYCEthnicCN-ETH-ML': 'Mulao',
    'KYCEthnicCN-ETH-QI': 'Qiang',
    'KYCEthnicCN-ETH-BL': 'Blang',
    'KYCEthnicCN-ETH-SL': 'Salar',
    'KYCEthnicCN-ETH-MN': 'Maonan',
    'KYCEthnicCN-ETH-GL': 'Gelao',
    'KYCEthnicCN-ETH-XB': 'Xibe',
    'KYCEthnicCN-ETH-AC': 'Achang',
    'KYCEthnicCN-ETH-PM': 'Pumi',
    'KYCEthnicCN-ETH-TA': 'Tajik',
    'KYCEthnicCN-ETH-NU': 'Nu',
    'KYCEthnicCN-ETH-UZ': 'Uzbek',
    'KYCEthnicCN-ETH-RS': 'Russian',
    'KYCEthnicCN-ETH-EW': 'Ewenki',
    'KYCEthnicCN-ETH-DE': "De'ang",
    'KYCEthnicCN-ETH-BN': 'Bonan',
    'KYCEthnicCN-ETH-YG': 'Yugur',
    'KYCEthnicCN-ETH-GI': 'Gin',
    'KYCEthnicCN-ETH-TT': 'Tatar',
    'KYCEthnicCN-ETH-DR': 'Derung',
    'KYCEthnicCN-ETH-OR': 'Oroqen',
    'KYCEthnicCN-ETH-HZ': 'Hezhen',
    'KYCEthnicCN-ETH-MB': 'Monba',
    'KYCEthnicCN-ETH-LB': 'Lhoba',
    'KYCEthnicCN-ETH-JN': 'Jino',
};
